import type { FormSelectOption } from '@practium/ui';
import type { FertilizerFormData } from '../types/products.types';

export const FERTILIZER_CATEGORY_OPTIONS: FormSelectOption[] = [
	{ value: 'fertilizer', label: 'Fertilizante' },
	{ value: 'lime', label: 'Corretivo' },
	{ value: 'conditioner', label: 'Condicionador' },
	{ value: 'organic', label: 'Organomineral' },
	{ value: 'special', label: 'Especial / Bioestimulante' },
];

export const getFertilizerCategoryLabel = (category: string): string =>
	FERTILIZER_CATEGORY_OPTIONS.find((option) => option.value === category)?.label ?? category;

export const FERTILIZER_NATURE_OPTIONS: FormSelectOption[] = [
	{ value: 'solid', label: 'Sólido' },
	{ value: 'liquid', label: 'Líquido' },
];

export const APPLICATION_METHODS: FormSelectOption[] = [
	{ value: 'broad', label: 'Lanço' },
	{ value: 'irrigation', label: 'Fertirrigação' },
	{ value: 'foliar', label: 'Foliar' },
];

export const MACROS: { key: string; label: string }[] = [
	{ key: 'N', label: 'Nitrogênio (N)' },
	{ key: 'P2O5', label: 'Fósforo (P₂O₅)' },
	{ key: 'K2O', label: 'Potássio (K₂O)' },
	{ key: 'Ca', label: 'Cálcio (Ca)' },
	{ key: 'Mg', label: 'Magnésio (Mg)' },
	{ key: 'S', label: 'Enxofre (S)' },
	{ key: 'C', label: 'Carbono (C)' },
];

export const MICROS: { key: string; label: string }[] = [
	{ key: 'B', label: 'Boro (B)' },
	{ key: 'Cu', label: 'Cobre (Cu)' },
	{ key: 'Fe', label: 'Ferro (Fe)' },
	{ key: 'Mn', label: 'Manganês (Mn)' },
	{ key: 'Zn', label: 'Zinco (Zn)' },
	{ key: 'Mo', label: 'Molibdênio (Mo)' },
];

export const CORRECTIVOS: { key: string; label: string }[] = [
	{ key: 'CaO', label: 'Cálcio Óxido (CaO)' },
	{ key: 'MgO', label: 'Magnésio Óxido (MgO)' },
	{ key: 'PRNT', label: 'PRNT (%)' },
];

export const ALL_NUTRIENT_KEYS = [
	'N', 'P2O5', 'K2O', 'Ca', 'Mg', 'S', 'C',
	'B', 'Cu', 'Fe', 'Mn', 'Zn', 'Mo',
	'CaO', 'MgO', 'PRNT',
] as const;

export const DEFAULT_FERTILIZER_FORM: FertilizerFormData = {
	name: '',
	manufacturerId: '',
	category: '',
	applicationMethods: [],
	nature: '',
	active: true,
	note: '',
	N: '', P2O5: '', K2O: '', Ca: '', Mg: '', S: '', C: '',
	B: '', Cu: '', Fe: '', Mn: '', Zn: '', Mo: '',
	CaO: '', MgO: '', PRNT: '',
	solubleSaltFraction: '',
};
